module.exports = __webpack_public_path__ + "img/result-banner.e95f7228.png";